import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const onex = o_util.onex ?? {};
const isOnexVariant = onex.isOnexVariant;
const mapOnexVariant = onex.mapOnexVariant;
const withOnex = onex.withOnex;
const customAssignments = onex.customAssignments;
const onexAsync = otto.onex ?? {};
const assignments = onexAsync.assignments;
export {
  assignments,
  customAssignments,
  isOnexVariant,
  mapOnexVariant,
  onex,
  onexAsync,
  withOnex
};
/*                                    */
